export const commonFormUiVersion = 'dev';
